import { Button } from 'primereact/button';
import React from 'react';

const ActionBtn = ({icon,severity,tooltip,handleClick}) => {
    return (
        <Button
          icon={icon}
          rounded
          text
          outlined
          raised
          severity={severity}
          size="small"
          tooltip={tooltip}
          tooltipOptions={{
            position: "bottom",
            mouseTrack: true,
            mouseTrackTop: 15,
          }}
          onClick={handleClick}
        />
    );
};

export default ActionBtn;